module.exports = __webpack_public_path__ + "static/media/down.31823443.svg";